import { render } from "./MainMamps.vue?vue&type=template&id=5540460a&scoped=true"
import script from "./MainMamps.vue?vue&type=script&lang=js"
export * from "./MainMamps.vue?vue&type=script&lang=js"

import "./MainMamps.vue?vue&type=style&index=0&id=5540460a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5540460a"]])

export default __exports__